module.exports = __webpack_public_path__ + "static/img/2.2728183.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.png
// module id = chPc
// module chunks = 5